<template>
  <section class="relative w-full bg-[#161816] pb-[47px] pt-[4rem] lg:pb-[156px] flex flex-col items-center justify-center overflow-hidden px-5 lg:px-32" :class="homepage ? 'lg:pt-[20rem]' : 'lg:pt-[8rem]'">
    <div class="flex flex-col lg:flex-row items-center justify-between lg:gap-x-[3rem] xl:gap-x-[7.5rem]">
      <!-- Left: Text and Button -->
      <div
        ref="leftGroup"
        class="w-full lg:w-1/2 flex flex-col items-start lg:items-start mb-8 lg:mb-0 opacity-0 translate-y-10"
      >
        <h2 class="text-white text-[30px] lg:text-[5vw] xl:text-[80px] font-[500]">Get in touch.</h2>
        <p class="text-white text-[12px] lg:text-[16px] xl:text-[24px] font-[500] mt-[1rem] lg:mt-[2rem]">
          Get in contact below. Together we can achieve your goals through innovative advertising solutions, comprehensive data-driven insights, and explosive growth.
        </p>
        <button class="cta-button mt-[3rem] lg:mt-[4rem]" ref="ctaButton" @click="goToContactUs">
  <span class="text text-[12px] lg:text-[24px]">Book a call</span>
        <svg class="arrow hidden lg:block" xmlns="http://www.w3.org/2000/svg" width="35" height="19" viewBox="0 0 35 19" fill="none">
          <path d="M1 9.27539H33.0682" stroke="#52DA75" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M25.8932 1L32.2859 7.39262C33.328 8.4347 33.328 10.1277 32.2859 11.1698L25.8932 17.5624" stroke="#52DA75" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
            <svg class="lg:hidden" xmlns="http://www.w3.org/2000/svg" width="25" height="14" viewBox="0 0 25 14" fill="none">
    <path d="M1 7.27686H24" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18.854 1.3418L23.4389 5.92672C24.1863 6.67413 24.1863 7.8884 23.4389 8.63581L18.854 13.2207" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</button>
      </div>
      <!-- Right: Contact Card with SVG background -->
      <div class="hidden lg:block relative w-full lg:w-1/2 aspect-[592/259] flex items-center justify-center">
        <svg style="filter: drop-shadow(0px 0px 5px #52DA75);backface-visibility: hidden;will-change: transform;contain: layout style paint;" class="box absolute inset-0 w-full h-full z-0 pointer-events-none"  xmlns="http://www.w3.org/2000/svg" width="592" height="259" viewBox="0 0 592 259" fill="none">
          <g filter="url(#filter0_d_1024_223)">
            <path d="M480.735 236.657L569.656 147.751C571.157 146.25 572 144.215 572 142.093L572 28C572 23.5817 568.418 20 564 20L28 20C23.5817 20 20 23.5817 20 28L20 231C20 235.418 23.5817 239 28 239L475.078 239C477.2 239 479.234 238.157 480.735 236.657Z" fill="#161816"/>
          </g>
          <defs>
            <filter id="filter0_d_1024_223" x="0" y="0" width="592" height="259" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset/>
              <feGaussianBlur stdDeviation="5"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0.321569 0 0 0 0 0.854902 0 0 0 0 0.458824 0 0 0 1 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1024_223"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1024_223" result="shape"/>
            </filter>
          </defs>
        </svg>
        <!--        <svg class="box absolute inset-0 w-full h-full z-0 pointer-events-none" width="592" height="259" viewBox="0 0 592 259" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--          <g filter="url(#filter0_d_0_1)">-->
<!--            <path d="M480.735 236.657L569.656 147.751C571.157 146.25 572 144.215 572 142.093L572 28C572 23.5817 568.418 20 564 20L28 20C23.5817 20 20 23.5817 20 28L20 231C20 235.418 23.5817 239 28 239L475.078 239C477.2 239 479.234 238.157 480.735 236.657Z" fill="#161816"/>-->
<!--          </g>-->
<!--          <g filter="url(#filter1_d_0_1)">-->
<!--            <path d="M480.735 236.657L569.656 147.751C571.157 146.25 572 144.215 572 142.093L572 28C572 23.5817 568.418 20 564 20L28 20C23.5817 20 20 23.5817 20 28L20 231C20 235.418 23.5817 239 28 239L475.078 239C477.2 239 479.234 238.157 480.735 236.657Z" fill="#161816"/>-->
<!--          </g>-->
<!--          <defs>-->
<!--            <filter id="filter0_d_0_1" x="0" y="0" width="592" height="259" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">-->
<!--              <feFlood flood-opacity="0" result="BackgroundImageFix"/>-->
<!--              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>-->
<!--              <feOffset/>-->
<!--              <feGaussianBlur stdDeviation="10"/>-->
<!--              <feComposite in2="hardAlpha" operator="out"/>-->
<!--              <feColorMatrix type="matrix" values="0 0 0 0 0.321569 0 0 0 0 0.854902 0 0 0 0 0.458824 0 0 0 1 0"/>-->
<!--              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1"/>-->
<!--              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape"/>-->
<!--            </filter>-->
<!--            <filter id="filter1_d_0_1" x="0" y="0" width="592" height="259" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">-->
<!--              <feFlood flood-opacity="0" result="BackgroundImageFix"/>-->
<!--              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>-->
<!--              <feOffset/>-->
<!--              <feGaussianBlur stdDeviation="10"/>-->
<!--              <feComposite in2="hardAlpha" operator="out"/>-->
<!--              <feColorMatrix type="matrix" values="0 0 0 0 0.321569 0 0 0 0 0.854902 0 0 0 0 0.458824 0 0 0 1 0"/>-->
<!--              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1"/>-->
<!--              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape"/>-->
<!--            </filter>-->
<!--          </defs>-->
<!--        </svg>-->

        <!--        <svg class="box absolute inset-0 w-full h-full z-0 pointer-events-none" xmlns="http://www.w3.org/2000/svg" width="592" height="259" viewBox="0 0 592 259" fill="none">-->
<!--  <g filter="url(#filter0_d_346_1744)">-->
<!--    <path d="M480.735 236.657L569.656 147.751C571.157 146.25 572 144.215 572 142.093L572 28C572 23.5817 568.418 20 564 20L28 20C23.5817 20 20 23.5817 20 28L20 231C20 235.418 23.5817 239 28 239L475.078 239C477.2 239 479.234 238.157 480.735 236.657Z" fill="#161816"/>-->
<!--  </g>-->
<!--  <defs>-->
<!--    <filter id="filter0_d_346_1744" x="0" y="0" width="592" height="259" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">-->
<!--      <feFlood flood-opacity="0" result="BackgroundImageFix"/>-->
<!--      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>-->
<!--      <feOffset/>-->
<!--      <feGaussianBlur stdDeviation="10"/>-->
<!--      <feComposite in2="hardAlpha" operator="out"/>-->
<!--      <feColorMatrix type="matrix" values="0 0 0 0 0.321569 0 0 0 0 0.854902 0 0 0 0 0.458824 0 0 0 1 0"/>-->
<!--      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_346_1744"/>-->
<!--      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_346_1744" result="shape"/>-->
<!--    </filter>-->
<!--  </defs>-->
<!--</svg>-->

        <div
          ref="cardGroup"
          class="relative z-10 w-full h-full flex flex-col justify-center p-[2rem] xl:p-[3rem] 2xl:p-[5rem]"
          style="min-height: 220px;"
        >
          <div class="flex flex-col gap-2">
            <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2 text-white lg:mb-1 xl:mb-4">
              <span class="whitespace-nowrap lg:text-[12px] xl:text-[16px]">+44 74154 87420</span>
              <span class="hidden sm:inline-block mx-2 lg:text-[12px] xl:text-[16px]">|</span>
              <span class="whitespace-nowrap lg:text-[12px] xl:text-[16px]">info@catalyst-growth.com</span>
            </div>
            <div class="text-white text-sm leading-6">
              <div class="lg:text-[12px] xl:text-[16px]">Catalyst Growth</div>
              <div class="lg:text-[12px] xl:text-[16px]">5 Piano Factory,</div>
              <div class="lg:text-[12px] xl:text-[16px]">London.</div>
              <div class="lg:text-[12px] xl:text-[16px]">SE5 8GB</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { gsap } from 'gsap';
import {useRouter} from "vue-router";

defineProps<{
  homepage?: boolean;
}>();

const router = useRouter()
const leftGroup = ref<HTMLElement | null>(null);
const cardGroup = ref<HTMLElement | null>(null);
let observers: IntersectionObserver[] = [];

const goToContactUs = () => {
  window.open("https://app.usemotion.com/meet/toby-green-bbrz/catalyst?d=30", "_blank");
};

function animateIn(el: HTMLElement) {
  gsap.to(el, {
    opacity: 1,
    y: 0,
    duration: 1,
    ease: 'power3.out',
    overwrite: 'auto',
  });
}
function animateOut(el: HTMLElement) {
  gsap.to(el, {
    opacity: 0,
    y: 100,
    duration: 1,
    ease: 'power3.in',
    overwrite: 'auto',
  });
}

onMounted(() => {
  [leftGroup, cardGroup].forEach((elRef) => {
    if (!elRef.value) return;
    gsap.set(elRef.value, { opacity: 0, y: 40 });
    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateIn(elRef.value!);
        } else {
          animateOut(elRef.value!);
        }
      });
    }, { threshold: 0.2 });
    observer.observe(elRef.value);
    observers.push(observer);
  });
});

onUnmounted(() => {
  observers.forEach(o => o.disconnect());
  observers = [];
});
</script>

<style scoped>
.neon-card {
  box-shadow: 0 0 0 2px #52E47533, 0 0 16px 2px #52E47544;
  position: relative;
  z-index: 1;
}
@media (max-width: 1023px) {
  .neon-card {
    width: 100% !important;
    margin-top: 2rem;
  }
}
.cta-button {
  background: transparent;
  color: white;
  border: 1px solid #ffffff;
  padding: 8px 16px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
</style>
